/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  StaticHTMLContext
 */

import { createContext } from 'react'
import type { createBrowserStaticRender } from './createBrowserStaticRender'
import type { serverStaticRender } from './createServerStaticRender'

export const StaticHTMLContext = createContext<
  null | ReturnType<typeof createBrowserStaticRender> | typeof serverStaticRender
>(null)
